import { FirestoreDataConverter } from "firebase/firestore";
import moment from "moment";
import { parseAbatimentos } from "../models/abatimentos";
import { parseDarf } from "../models/darf";
import Imposto from "../models/imposto";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class ImpostoDb extends BaseDb<
  Imposto,
  { usuarioId: string; impostoId: string }
> {
  _path: string = "usuarios/usuarioId/impostos/impostoId";
  getConverter(): FirestoreDataConverter<Imposto> {
    return {
      fromFirestore: (snapshot, _options) =>
        new Imposto({
          criadoEm: moment(snapshot.get("criadoEm").toDate()),
          dataBase: moment(snapshot.get("dataBase").toDate()),
          pontoDePartida: snapshot.get("pontoDePartida"),
          darf: snapshot.get("darf")
            ? parseDarf(snapshot.get("darf"))
            : undefined,
          abatimentos: parseAbatimentos(snapshot.get("abatimentos")),
          resultado: snapshot.get("resultado"),
        }),
      toFirestore: (imposto: Imposto) => {
        if (!!!imposto.pontoDePartida) {
          throw new Error("Não é possível criar um imposto");
        } else {
          return toFirestore(imposto);
        }
      },
    };
  }
}
